import defaultConfig from './clients/default'
import lessus from './clients/lessus'
import grandvillard from './clients/grandvillard'
import farvagny from './clients/farvagny'

// process.env.CLIENT est injecté au build par Parcel via les scripts npm (ex: `npm run build:lessus`).
// Pour ajouter un client : créer ./clients/<nom>.js, l'importer ci-dessus et l'ajouter à la map.
const clientsMap = { lessus, grandvillard, farvagny }
const clientConfig = clientsMap[process.env.CLIENT] || defaultConfig

// En dev (parcel serve), on garde imagesProxyUrl='' pour laisser .proxyrc.json intercepter /api.
// En prod (parcel build), on utilise l'URL absolue définie dans la config du client.
const isDev = process.env.NODE_ENV !== 'production'

export const appTitle = clientConfig.appTitle
export const imagesProxyUrl = isDev ? '' : clientConfig.imagesProxyUrl

// WebSocket discovery endpoint (/ureq) — gateway commun, indépendant du client.
// Le client POST {"apikey": "..."} et reçoit {"wsUrl": "...", "token": "...", "expiresIn": 3600}
// Le token est utilisé comme subprotocol "bearer.<token>" lors de l'ouverture de la WS.
export const ureqUrl = 'https://webmobile.gw.mimatech.ch/ureq'
export const heartbeatInterval = 30000  // 30 secondes
